import { SavedFilterInterface } from '../../../interfaces/saved-filter.interface';

export class LoadFiltersSuccessAction {
    public static readonly type = '[JobsPlacements] Load filters success';

    constructor(public payload: Array<SavedFilterInterface>) { }
}
